/** FF005 — bank account details (stored in bank_account_details_form). */

export type BankTypeCode = 'bank' | 'shinkin' | 'shingumi' | 'nokyo' | 'other';

export type AccountTypeCode = 'ordinary' | 'current';

export type BankAccountFormValues = {
  consentGiven?: 'true' | 'false';
  consentDate?: string;
  bankName?: string;
  bankType?: BankTypeCode;
  bankTypeOther?: string;
  branchName?: string;
  accountType?: AccountTypeCode;
  accNum?: string;
  nameKana?: string;
};

/** Official Japanese labels — always shown for bank/account type answers regardless of UI language. */
export const BANK_TYPE_LABEL_JA: Record<BankTypeCode, string> = {
  bank: '銀行',
  shinkin: '信金',
  shingumi: '信組',
  nokyo: '農協',
  other: 'その他',
};

export const ACCOUNT_TYPE_LABEL_JA: Record<AccountTypeCode, string> = {
  ordinary: '普通',
  current: '当座',
};

export const BANK_TYPE_OPTIONS: ReadonlyArray<{ value: BankTypeCode; labelKey: string }> = [
  { value: 'bank', labelKey: 'submitDocuments.bankAccountDetails.bankType.bank' },
  { value: 'shinkin', labelKey: 'submitDocuments.bankAccountDetails.bankType.shinkin' },
  { value: 'shingumi', labelKey: 'submitDocuments.bankAccountDetails.bankType.shingumi' },
  { value: 'nokyo', labelKey: 'submitDocuments.bankAccountDetails.bankType.nokyo' },
  { value: 'other', labelKey: 'submitDocuments.bankAccountDetails.bankType.other' },
];

export const ACCOUNT_TYPE_OPTIONS: ReadonlyArray<{ value: AccountTypeCode; labelKey: string }> = [
  { value: 'ordinary', labelKey: 'submitDocuments.bankAccountDetails.accountType.ordinary' },
  { value: 'current', labelKey: 'submitDocuments.bankAccountDetails.accountType.current' },
];

export const ACCOUNT_NUM_MAX_LEN = 7;
